import Image from 'next/image';

import { ImageCopyright } from '../../../design-system/components/image/copyright/ImageCopyright';
import { Ratio, RATIO } from '../../../design-system/components/ratio/Ratio';
import { BigPictureSlice } from '../../../domains/Prismic/DestinationDetailDocument';
import { NullableSlice } from '../../../domains/Prismic/Utilities';

import style from './BigPicture.module.css';

export type BigPictureProps = {
    bigPicture: NullableSlice<BigPictureSlice>;
};

export function BigPicture({ bigPicture }: BigPictureProps) {
    const { picture, pictureCopyright } = bigPicture;

    return (
        <Ratio ratio={RATIO['16/9']}>
            {picture?.url ? (
                <Image
                    className={style.image}
                    alt={picture.alt}
                    src={picture.url}
                    unoptimized
                    fill
                />
            ) : null}

            {pictureCopyright ? <ImageCopyright copyright={pictureCopyright} /> : null}
        </Ratio>
    );
}
